var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('v-view-link',{staticClass:"nav-link",attrs:{"view":_vm.$views.Login,"display-title":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }